<template>

  <div style="background-color: #F99A03FF" class="container" id="main">
    <div class="d-flex justify-content-center flex-column align-items-center animate__animated animate__fadeIn">

      <br>
      <br>
      <br>
      <img class="h-50 w-50" src='../assets/Gifts/logo.gif' alt="">


      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>

      <div class="">
        <div class="d-flex flex-column align-items-center w-100 position-relative">
          <img class="decoban" src="../assets/Gifts/decoban.gif" alt="">
          <img style="width: 15%;z-index: 1" src="../assets/Gifts/000.gif" alt="">
        </div>
      </div>

    </div>
  </div>


  <div style="background-color: #F99A03FF" class="container-fluid" id="web">
    <div class="d-flex justify-content-center flex-column align-items-center animate__animated animate__fadeIn">

      <br>
      <br>

      <img class="h-30 w-30" src='../assets/Gifts/logo.gif' alt="">

      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>

      <div class="">
        <div class="d-flex flex-column align-items-center w-100 position-relative">
          <img class="decoban" src="../assets/Gifts/decoban.gif" alt="">
          <img style="width: 15%;z-index: 1" src="../assets/Gifts/000.gif" alt="">
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import router from "@/router";
import Swal from "sweetalert2";
import {useStore} from "vuex";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";


export default {
  name: 'SplashPage',
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let user_id

    try {
      user_id = FreeWorld.PinkMan(localStorage.getItem('uid'), 'de')
    } catch (e) {
      console.log(e.message)
      user_id = null
    }

    let store = useStore()

    store.commit('set_check_orders', true)
    store.commit('set_message', true)

    function check_updating() {

      FreeWorld.Heisenberg({action: 'updating'}, 'version').then((res) => {

        if (res.data == 1) {
          Swals.Updating()
        } else {
         runApp()
        }

      }).catch((res) => {

        Swals.Catch(res, check_updating, true)

      })
    }

    check_updating()

    function runApp() {

      if (!user_id) {

        router.push({name:'InformationPage'})

      } else {

        FreeWorld.Heisenberg({}, 'user_block', true).then((result) => {

          let res = result.data
          if (res.status !== 'block') {

            FreeWorld.Heisenberg({action: 'show'}, 'user_edit', true).then((result) => {

              let res = result.data
              store.commit('set_my_profile', res)

              router.push({name:'HomePage'})

            }).catch((res)=>{
              Swals.Catch(res, runApp, true)
            })

          } else {

            Swal.fire({
              text: "متاسفانه پروفایل شما توسط مدیریت مسدود شده است!",
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "متوجه شدم",
              allowOutsideClick: false,
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then((result) => {
              if (result.isConfirmed) {
                localStorage.clear()
                store.commit('empty_state')
                window.location.href = '/LoginPage'
              }
            });

          }

        }).catch((res) => {
          Swals.Catch(res, runApp, true)
        })

      }
    }

    return {}
  }
}


</script>

<style scoped>

.decoban {
  width: 50%;
  position: absolute;
  bottom: 0;
}

</style>